(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[23144,65250],{

/***/ 23144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ClearYourDebtsFastWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/shared/header/index.tsx
var header = __webpack_require__(74206);
// EXTERNAL MODULE: ./src/hooks/useModalContext.tsx
var useModalContext = __webpack_require__(67379);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/styles/variables/debtreliefhouseVariables.module.scss
var debtreliefhouseVariables_module = __webpack_require__(81276);
var debtreliefhouseVariables_module_default = /*#__PURE__*/__webpack_require__.n(debtreliefhouseVariables_module);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx + 1 modules
var mobile = __webpack_require__(8281);
;// CONCATENATED MODULE: ./src/components/clearyourdebtsfast/logo/index.tsx


function ClearYourDebtsFastLogo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "335",
        height: "40",
        fill: "none",
        viewBox: "0 0 335 40",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_60_132)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#89B4C3",
                        d: "M78.09 30.873c-1.019.51-3.05 1.019-5.653 1.019-6.035 0-10.578-3.815-10.578-10.833 0-7.018 4.543-11.245 11.184-11.245 2.669 0 4.354.57 5.083.953l-.667 2.256c-1.05-.51-2.542-.892-4.32-.892-5.02 0-8.357 3.209-8.357 8.832 0 5.24 3.02 8.607 8.23 8.607 1.686 0 3.397-.352 4.513-.892l.57 2.19-.005.005zM81.462 9.02h2.796v22.556h-2.796V9.02zM90.517 24.395c.061 3.78 2.48 5.338 5.271 5.338 2.002 0 3.209-.352 4.258-.795l.479 2.002c-.983.443-2.67.952-5.114.952-4.731 0-7.563-3.112-7.563-7.751 0-4.64 2.73-8.292 7.212-8.292 5.021 0 6.356 4.416 6.356 7.242 0 .57-.061 1.019-.097 1.304H90.517zm8.195-2.001c.03-1.778-.729-4.543-3.876-4.543-2.827 0-4.064 2.607-4.288 4.543h8.163zM113.389 31.576l-.224-1.94h-.097c-.855 1.207-2.51 2.287-4.7 2.287-3.112 0-4.701-2.19-4.701-4.416 0-3.718 3.305-5.75 9.244-5.72v-.315c0-1.273-.352-3.56-3.494-3.56-1.431 0-2.924.443-4.003 1.146l-.637-1.844c1.273-.825 3.112-1.365 5.052-1.365 4.701 0 5.847 3.209 5.847 6.29v5.75c0 1.334.061 2.638.255 3.687h-2.542zm-.412-7.848c-3.051-.061-6.514.479-6.514 3.463 0 1.813 1.207 2.669 2.638 2.669 2.002 0 3.27-1.273 3.718-2.572.097-.285.158-.606.158-.891v-2.669zM120.188 20.998c0-1.813-.03-3.366-.127-4.797h2.445l.096 3.02h.128c.698-2.063 2.383-3.367 4.258-3.367.315 0 .539.03.794.097v2.638a4.309 4.309 0 00-.952-.096c-1.971 0-3.367 1.492-3.749 3.59a8.153 8.153 0 00-.127 1.304v8.194h-2.766V20.998zM136.267 31.576v-9.085l-6.769-12.325h3.148l3.02 5.907a92.024 92.024 0 012.129 4.416h.061c.606-1.396 1.334-2.796 2.159-4.416l3.082-5.908h3.147l-7.181 12.295v9.116h-2.796zM160.092 23.759c0 5.688-3.937 8.164-7.655 8.164-4.161 0-7.37-3.051-7.37-7.91 0-5.149 3.367-8.164 7.625-8.164 4.257 0 7.4 3.209 7.4 7.91zm-12.198.157c0 3.367 1.94 5.908 4.67 5.908s4.671-2.51 4.671-5.974c0-2.607-1.304-5.908-4.604-5.908-3.301 0-4.732 3.051-4.732 5.974h-.005zM176.486 27.38c0 1.589.03 2.984.127 4.191h-2.48l-.158-2.51h-.061c-.733 1.237-2.353 2.857-5.083 2.857-2.414 0-5.307-1.335-5.307-6.733v-8.99h2.796v8.516c0 2.923.892 4.894 3.433 4.894 1.874 0 3.178-1.303 3.687-2.541a4.11 4.11 0 00.255-1.431v-9.437h2.796V27.38h-.005zM181.126 20.998c0-1.813-.031-3.366-.128-4.797h2.445l.097 3.02h.127c.698-2.063 2.383-3.367 4.258-3.367.315 0 .539.03.794.097v2.638a4.309 4.309 0 00-.952-.096c-1.971 0-3.367 1.492-3.749 3.59a8.153 8.153 0 00-.127 1.304v8.194h-2.765V20.998z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#71ABBE",
                        d: "M194.138 31.576V9.254h8.052c2.139 0 4.1.489 5.877 1.472a11.154 11.154 0 014.227 4.028c1.039 1.706 1.559 3.596 1.559 5.674 0 2.078-.515 3.962-1.548 5.663a11.096 11.096 0 01-4.212 4.018c-1.773.978-3.723 1.472-5.852 1.472h-8.103v-.005zm8.245-4.084c1.325 0 2.527-.306 3.616-.922a6.716 6.716 0 002.557-2.536c.621-1.08.927-2.282.927-3.616 0-1.335-.311-2.542-.937-3.621a6.768 6.768 0 00-2.572-2.542c-1.09-.616-2.302-.922-3.636-.922h-3.891v14.154h3.942l-.006.005zM220.316 24.614c.265 1.187.835 2.119 1.706 2.796.876.678 1.91 1.019 3.107 1.019 1.533 0 2.852-.51 3.957-1.523l1.94 2.811a8.668 8.668 0 01-2.74 1.701c-1.034.403-2.164.606-3.392.606-1.619 0-3.086-.387-4.39-1.166a8.354 8.354 0 01-3.076-3.168c-.743-1.334-1.11-2.79-1.11-4.37 0-1.578.351-3.065 1.049-4.4a8.09 8.09 0 012.913-3.168c1.243-.779 2.638-1.166 4.187-1.166 1.706 0 3.178.367 4.415 1.105a7.246 7.246 0 012.827 3.056c.646 1.304.967 2.791.967 4.467 0 .509-.03.978-.096 1.416h-12.264v-.016zm1.573-5.617c-.763.61-1.278 1.451-1.543 2.536h8.419c-.244-1.1-.723-1.95-1.436-2.552-.713-.596-1.62-.896-2.71-.896-1.09 0-1.971.306-2.735.912h.005zM249.132 15.727a8.587 8.587 0 013.055 3.163c.759 1.329 1.136 2.786 1.136 4.375s-.377 3.045-1.125 4.374a8.596 8.596 0 01-3.056 3.163 7.944 7.944 0 01-4.187 1.166c-1.059 0-2.016-.208-2.877-.626a7.024 7.024 0 01-2.241-1.721l-.285 1.955h-3.545V8.144h4.085v8.464c1.293-1.365 2.913-2.047 4.858-2.047 1.503 0 2.898.387 4.177 1.166h.005zm-2.134 11.78a4.462 4.462 0 001.691-1.732c.412-.743.621-1.573.621-2.495 0-.922-.209-1.757-.621-2.5a4.555 4.555 0 00-1.701-1.758 4.63 4.63 0 00-2.384-.636c-.871 0-1.686.213-2.414.636a4.597 4.597 0 00-1.732 1.757c-.422.749-.636 1.579-.636 2.5 0 .923.214 1.753.636 2.486a4.565 4.565 0 001.732 1.732 4.766 4.766 0 002.414.626c.881 0 1.676-.209 2.394-.621v.005zM261.141 31.576h-4.069v-12.93h-2.384v-3.734h2.368V10.94l4.085-.968v4.94h3.672v3.733h-3.672v12.931zM268.846 31.352a12.462 12.462 0 01-3.432-1.843l1.92-2.858c.718.51 1.568.943 2.551 1.294.978.357 1.936.53 2.868.53.804 0 1.441-.143 1.915-.428.468-.285.708-.688.708-1.207 0-.352-.123-.647-.367-.891-.245-.245-.632-.469-1.161-.683-.53-.214-1.263-.433-2.206-.667-1.65-.413-2.974-1.039-3.962-1.884-.988-.84-1.487-1.92-1.487-3.235 0-.921.265-1.756.795-2.5.529-.749 1.298-1.34 2.302-1.778 1.008-.438 2.2-.656 3.575-.656 1.039 0 2.113.183 3.234.55a10.87 10.87 0 013.01 1.517l-1.941 2.908c-.58-.382-1.288-.708-2.118-.983-.83-.275-1.615-.412-2.343-.412-.795 0-1.396.127-1.803.382-.407.254-.611.606-.611 1.049 0 .306.102.57.311.794.208.225.555.433 1.038.627.489.193 1.177.412 2.063.642 1.217.305 2.246.672 3.081 1.09.836.417 1.498.962 1.976 1.634.484.673.724 1.503.724 2.486 0 .983-.275 1.874-.825 2.658-.55.79-1.33 1.41-2.333 1.86-1.008.447-2.154.676-3.448.676-1.431 0-2.776-.224-4.034-.667v-.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#89B4C3",
                        d: "M285.668 10.16h11.531v2.318h-8.77v7.115h8.103v2.286h-8.103v9.692h-2.766v-21.41h.005zM308.128 31.576l-.224-1.94h-.097c-.855 1.207-2.51 2.287-4.7 2.287-3.112 0-4.701-2.19-4.701-4.416 0-3.718 3.305-5.75 9.244-5.72v-.315c0-1.273-.352-3.56-3.494-3.56-1.431 0-2.924.443-4.003 1.146l-.637-1.844c1.273-.825 3.112-1.365 5.052-1.365 4.701 0 5.847 3.209 5.847 6.29v5.75c0 1.334.061 2.638.255 3.687h-2.542zm-.412-7.848c-3.051-.061-6.514.479-6.514 3.463 0 1.813 1.207 2.669 2.638 2.669 2.002 0 3.27-1.273 3.718-2.572.097-.285.158-.606.158-.891v-2.669zM314.551 28.714c.825.54 2.286 1.11 3.687 1.11 2.032 0 2.984-1.018 2.984-2.286 0-1.335-.794-2.063-2.857-2.827-2.765-.983-4.064-2.51-4.064-4.354 0-2.48 2.001-4.513 5.307-4.513 1.558 0 2.923.443 3.779.953l-.698 2.032a5.966 5.966 0 00-3.142-.892c-1.65 0-2.572.953-2.572 2.099 0 1.273.922 1.843 2.923 2.602 2.669 1.019 4.034 2.353 4.034 4.64 0 2.7-2.099 4.604-5.75 4.604-1.686 0-3.239-.413-4.319-1.05l.698-2.128-.01.01zM330.878 11.785v4.416h4.004v2.128h-4.004v8.292c0 1.905.54 2.984 2.099 2.984.733 0 1.273-.096 1.619-.188l.128 2.098c-.54.224-1.401.382-2.481.382-1.303 0-2.353-.412-3.02-1.176-.794-.825-1.079-2.19-1.079-4.003v-8.389h-2.384v-2.128h2.384v-3.688l2.734-.728z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#71ABBE",
                        d: "M37.066 30.064c-1.665 0-1.665-2.532 0-2.532h5.76c1.666 0 1.666 2.532 0 2.532h-5.76zM26.6 30.064c-1.665 0-1.665-2.532 0-2.532h5.76c1.666 0 1.666 2.532 0 2.532H26.6zM19.521 30.064c-1.665 0-1.665-2.532 0-2.532h2.374c1.665 0 1.665 2.532 0 2.532H19.52zM38.396.387l-3.642 3.641H5.073A5.086 5.086 0 000 9.101v21.798a5.089 5.089 0 003.178 4.706l-2.22 2.22c-1.177 1.177.61 2.97 1.787 1.788L40.188 2.175c1.177-1.177-.61-2.97-1.787-1.788h-.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#71ABBE",
                        d: "M43.422 4.029A5.083 5.083 0 0148.495 9.1V30.9a5.083 5.083 0 01-5.072 5.072H13.215c-1.665 0-1.665-2.53 0-2.53h30.206a2.557 2.557 0 002.547-2.547V9.1a2.557 2.557 0 00-2.547-2.546h-.789c-1.665 0-1.665-2.532 0-2.532h.79v.006z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_60_132",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H334.882V40H0z"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var logo = (ClearYourDebtsFastLogo);

;// CONCATENATED MODULE: ./src/components/layouts/clearYourDebtsFastWrapper.tsx









const Footer = dynamic_default()(()=>__webpack_require__.e(/* import() */ 60681).then(__webpack_require__.bind(__webpack_require__, 31701)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31701)
            ]
    }
});
const Modal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 84043).then(__webpack_require__.bind(__webpack_require__, 18740)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18740)
            ]
    }
});
const CloseIcon = dynamic_default()(()=>__webpack_require__.e(/* import() */ 69655).then(__webpack_require__.bind(__webpack_require__, 69655)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69655)
            ]
    }
});
const TermsAndConditions = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10761), __webpack_require__.e(14777)]).then(__webpack_require__.bind(__webpack_require__, 10761)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10761)
            ]
    }
});
const PrivacyPolicy = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57079), __webpack_require__.e(25591)]).then(__webpack_require__.bind(__webpack_require__, 57079)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57079)
            ]
    }
});
function ClearYourDebtsFastWrapper({ children  }) {
    const { modal , closeModal  } = (0,useModalContext/* useModal */.d)();
    const handleClose = ()=>{
        closeModal();
    };
    const { active: modalActive , content: modalContent  } = modal;
    const getModalContent = ()=>{
        switch(modalContent){
            case "privacy":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicy, {
                    category: "Debt Relief",
                    domain: "ClearYourDebtsFast.com"
                });
            case "terms":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditions, {
                    category: "Debt Relief",
                    domain: "ClearYourDebtsFast.com"
                });
            case "sideWidget":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile/* default */.Z, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;500;600;700&display=swap",
                        rel: "stylesheet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    fontFamily: `'Open Sans', sans-serif`
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header["default"], {
                        slogan: "Find the Right debt relief For You",
                        phoneNumberColor: (debtreliefhouseVariables_module_default()).mainColor,
                        iconColor: (debtreliefhouseVariables_module_default()).mainColor,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        className: "max-w-7xl mx-auto block px-4vw lg:px-4",
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                        onClose: handleClose,
                        active: modalActive,
                        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
                        backdropClosable: true,
                        modalStyles: {
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: modalContent === "sideWidget" ? "80vh" : "100%"
                        },
                        modalClassName: "h-[90vh] rounded",
                        bodyStyles: {
                            overflowY: "scroll"
                        },
                        width: 900,
                        header: modalContent === "privacy" ? "Privacy Policy" : modalContent === "terms" ? "Terms and Conditions" : modalContent === "sideWidget" ? "Contents" : undefined,
                        children: getModalContent()
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 74206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);
/* harmony import */ var _components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10621);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19255);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79961);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);








// import CloseIcon from "@components/svg/closeIcon";

function Header({ slogan , children , textColor , iconColor , backGroundColor , isLogoClickable =true , emptyIcon , boxShadow , border , phoneNumberColor , stickyStyle , hideSticky , logoClassName , useChildrenLogo , bannerStyleAsProp , className , useSecondaryLogo =false  }) {
    const { domain , blogPost , routeConfig , showFormModal , locale , defaultLocale , pageType ,  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    const { 0: headerHeight , 1: setHeaderHeight  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const header = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: bannerActive , 1: setBannerActive  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: hidePhoneNumber , 1: setHidePhoneNumber  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { query , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const bannerTextBlock = domain.textBlocks?.find((textBlock)=>textBlock.position === "banner");
    function showingBanner() {
        if (!bannerTextBlock) return false;
        if (pageType === "page-builder") {
            return !routeConfig?.config?.settings?.preHeaderText;
        }
        return true;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let prevHeight = "0";
        const observer = new ResizeObserver(([headerEntry])=>{
            if (header.current) {
                const height = headerEntry.borderBoxSize?.[0]?.blockSize.toFixed(0);
                if (height !== prevHeight) {
                    prevHeight = height;
                    setHeaderHeight(`${height}px`);
                }
            }
        });
        if (header.current) {
            observer.observe(header.current);
        }
        if (bannerTextBlock) {
            setTimeout(()=>{
                setBannerActive(true);
            }, 500);
        }
        if (sessionStorage.getItem(_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .SKIPPED_OPERATION_ID_KEY */ .UG) && asPath.includes("thank-you")) {
            setHidePhoneNumber(true);
        }
        return ()=>{
            if (header.current) {
                observer.unobserve(header.current);
            }
        };
    }, []);
    const logoFromVariantConfig = routeConfig?.templateConfig?.variantConfig?.logo;
    const logoPath = logoFromVariantConfig ?? routeConfig?.config?.settings?.logo ?? domain?.logo?.fullPath;
    const secondaryLogoPath = domain?.secondaryLogo?.fullPath ?? null;
    const callIconUnWrappedImage = routeConfig?.templateConfig?.headerAndFooter?.header?.callIconUnWrappedImage;
    const phoneNumberBlock = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "slogan items-center flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            slogan: slogan,
            textColor: textColor,
            iconColor: iconColor ?? textColor,
            emptyIcon: emptyIcon,
            phoneNumberColor: phoneNumberColor,
            stickyStyle: stickyStyle,
            hideSticky: hideSticky || showFormModal,
            iconPath: callIconUnWrappedImage
        })
    });
    const finalUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!isLogoClickable) {
            return undefined;
        }
        const homepageHref = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .getHomepageHref */ .$N)(query, locale, defaultLocale);
        if (homepageHref === undefined) {
            return undefined;
        }
        const withQueryParams = (0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start", [
            "genericRoute",
            "keyword",
            "category",
            "formTemplate",
            "tool",
            "slug",
            "data",
            "zc",
            "filters",
            "pii-token", 
        ]);
        return `${homepageHref}?${withQueryParams}`;
    }, [
        isLogoClickable,
        query
    ]);
    const variables = routeConfig?.config?.header?.variables;
    const styles = {
        backgroundColor: backGroundColor,
        boxShadow: boxShadow,
        borderBottom: border,
        ...variables ? (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_7__/* .convertToBreakpointVariables */ .Xz)(variables) : {}
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        style: styles,
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().header)} ${className}`,
        ref: header,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `ltrStyle inner py-5 lg:py-4 px-5 flex lg:max-w-7xl mx-auto  lg:px-6 items-center ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headerContainer)} `,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().logo)} ${logoClassName ? logoClassName : ""}`,
                        style: {
                            backgroundImage: `url(${useSecondaryLogo ? secondaryLogoPath : logoPath ?? ""})`,
                            width: "auto",
                            height: "auto",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            ...domain.name === "homewarranty.deals" ? {
                                maxWidth: "330px"
                            } : {}
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: finalUrl,
                            "aria-label": `${domain.name} logo`,
                            children: logoPath && !useChildrenLogo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: logoPath,
                                className: "h-auto w-full",
                                alt: `${domain.name} logo`,
                                style: {
                                    visibility: "hidden"
                                },
                                rel: "preload"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "children:w-full children:h-auto lg:children:h-10",
                                children: children
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            blogPost && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xs lg:flex hidden justify-end text-[#6b6b6b] ",
                                children: "Advertisement"
                            }),
                            !hidePhoneNumber && phoneNumberBlock
                        ]
                    }),
                    headerHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                        children: `:root {--header-height: ${headerHeight} }`
                    })
                ]
            }),
            showingBanner() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner)} ${bannerStyleAsProp ?? ""} ${bannerActive ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""}`,
                style: {
                    "--banner-background-color": domain?.config?.bannerBgColor,
                    "--banner-text-color": domain?.config?.bannerTextColor
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: bannerTextBlock?.text ?? ""
                    },
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["banner-inner"])
                })
            })
        ]
    });
}


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 79961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ extractUrl; },
/* harmony export */   "OZ": function() { return /* binding */ generateGlobalVariables; },
/* harmony export */   "XR": function() { return /* binding */ getFinalFontFamily; },
/* harmony export */   "Xz": function() { return /* binding */ convertToBreakpointVariables; },
/* harmony export */   "Z2": function() { return /* binding */ modifyCSSForElement; },
/* harmony export */   "hJ": function() { return /* binding */ minifyCSS; },
/* harmony export */   "uC": function() { return /* binding */ getFormTemplate; }
/* harmony export */ });
/* unused harmony export breakpoints */
const breakpoints = [
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
// ****** EXAMPLE INPUT ******
// variables = {
//     "titleSize": {
//         "sm": "14px",
//         "md": "16px",
//     },
//     "descriptionSize": "14px",
//     "titleColor": {
//          "sm": "red",
//          "lg": "blue",
//     },
// }
// ****** OUTPUT ******
// breakpointVariables = {
//     "--title-size-sm": "14px",
//     "--title-size-md" : "16px",
//     "--title-size-lg" : "16px",
//     "--title-size-xl" : "16px",
//     "--title-size-xxl" : "16px",
//     "--description-size-sm": "14px",
//     "--description-size-md": "14px",
//     "--description-size-lg": "14px",
//     "--description-size-xl": "14px",
//     "--description-size-xxl": "14px",
//     "--title-color-sm": "red",
//     "--title-color-md": "red",
//     "--title-color-lg": "blue",
//     "--title-color-xl": "blue",
//     "--title-color-xxl": "blue",
// }
/**
 * Convert variables object to css variables with breakpoints handled
 *
 * @param variables - variables object to convert
 * @param namespace - optional namespace to prefix variable names (e.g., "tabs", "accordion")
 */ function convertToBreakpointVariables(variables, namespace) {
    const breakpointVariables = {};
    for (const [key, value] of Object.entries(variables)){
        if (!value) continue;
        // Create variable name with optional namespace prefix
        const varName = namespace ? `${namespace}-${key}` : key;
        if (typeof value === "object") {
            const objValue = value;
            breakpoints.forEach((breakpoint, index)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = objValue[breakpoint] || objValue[breakpoints[index - 1]] || objValue[breakpoints[index - 2]] || objValue[breakpoints[index - 3]] || objValue[breakpoints[index - 4]] || objValue["sm"] || "unset";
            });
        } else {
            breakpoints.forEach((breakpoint)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = value;
            });
        }
    }
    return breakpointVariables;
}
function generateGlobalVariables(config) {
    const cssVariables = {};
    function recursiveGenerateCSSVariables(obj, prefix = "") {
        for(const key in obj){
            if (key in obj) {
                const value = obj[key];
                if (typeof value !== "string" && value !== null) {
                    recursiveGenerateCSSVariables(value, `${prefix}-${key}`);
                } else {
                    const variableName = `--${prefix}-${key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}`;
                    cssVariables[variableName] = value || "unset";
                }
            }
        }
    }
    recursiveGenerateCSSVariables(config, "global");
    return cssVariables;
}
const minifyCSS = (css)=>css.replace(/\n/g, "").replace(/\s\s+/g, " ");
function modifyCSSForElement(cssString, selector) {
    if (!cssString) return "";
    // At-rules that should have selector prepended to their inner rules
    const scopedAtRules = [
        "@media",
        "@supports",
        "@container",
        "@layer"
    ];
    // At-rules that should be kept as-is (no selector modification)
    const globalAtRules = [
        "@keyframes",
        "@-webkit-keyframes",
        "@-moz-keyframes",
        "@font-face",
        "@import",
        "@charset",
        "@namespace",
        "@page", 
    ];
    // Helper to prepend selector to simple CSS rules
    const prependSelectorToRules = (css)=>{
        const rules = css.split("}");
        return rules.map((rule)=>{
            const trimmed = rule.trim();
            if (trimmed === "") return "";
            const braceIndex = trimmed.indexOf("{");
            if (braceIndex === -1) return `${selector} ${trimmed}`;
            const selectorPart = trimmed.substring(0, braceIndex);
            const bodyPart = trimmed.substring(braceIndex);
            const scopedSelectors = selectorPart.split(",").map((s)=>`${selector} ${s.trim()}`).join(", ");
            return `${scopedSelectors} ${bodyPart}`;
        }).join("\n}\n");
    };
    // Find the closing brace that matches an opening brace (handles nesting)
    const findMatchingBrace = (str, startPos)=>{
        let braceCount = 1;
        let pos = startPos;
        while(braceCount > 0 && pos < str.length){
            if (str[pos] === "{") braceCount++;
            if (str[pos] === "}") braceCount--;
            pos++;
        }
        return pos;
    };
    // Find the next at-rule in the string
    const findNextAtRule = (str)=>{
        const allAtRules = [
            ...scopedAtRules,
            ...globalAtRules
        ];
        let earliest = null;
        for (const atRule of allAtRules){
            const index = str.indexOf(atRule);
            if (index !== -1 && (earliest === null || index < earliest.index)) {
                earliest = {
                    index,
                    type: atRule,
                    isScoped: scopedAtRules.includes(atRule)
                };
            }
        }
        return earliest;
    };
    // Recursively process CSS (handles nested at-rules)
    const processCSS = (css)=>{
        let result = "";
        let remaining = css;
        while(remaining.length > 0){
            const nextAtRule = findNextAtRule(remaining);
            if (!nextAtRule) {
                // No more at-rules, process remaining as regular rules
                result += prependSelectorToRules(remaining);
                break;
            }
            // Process any rules before this at-rule
            if (nextAtRule.index > 0) {
                const beforeAtRule = remaining.substring(0, nextAtRule.index);
                result += prependSelectorToRules(beforeAtRule);
            }
            // Find the opening brace for this at-rule
            const openBrace = remaining.indexOf("{", nextAtRule.index);
            if (openBrace === -1) {
                // No brace found (e.g., @import or @charset statement)
                const semicolon = remaining.indexOf(";", nextAtRule.index);
                if (semicolon !== -1) {
                    result += remaining.substring(nextAtRule.index, semicolon + 1);
                    remaining = remaining.substring(semicolon + 1);
                    continue;
                }
                break;
            }
            const atRuleHeader = remaining.substring(nextAtRule.index, openBrace).trim();
            const closeBrace = findMatchingBrace(remaining, openBrace + 1);
            const atRuleContent = remaining.substring(openBrace + 1, closeBrace - 1);
            if (nextAtRule.isScoped) {
                // Scoped at-rules: process inner content recursively
                const processedContent = processCSS(atRuleContent);
                result += `\n${atRuleHeader} {\n${processedContent}\n}\n`;
            } else {
                // Global at-rules: keep content as-is
                result += `\n${atRuleHeader} {\n${atRuleContent}\n}\n`;
            }
            remaining = remaining.substring(closeBrace);
        }
        return result;
    };
    return minifyCSS(processCSS(cssString));
}
const extractUrl = (input)=>{
    const match = input.match(/^url\((.+)\)$/);
    return match ? match[1] : "";
};
const getFormTemplate = (path)=>{
    if (path.includes("/free-consultation/v1")) {
        return "v1";
    }
    if (path.includes("/free-consultation/v2")) {
        return "v2";
    }
    return null;
};
const getFinalFontFamily = (routeConfig, locale, fontFamily)=>{
    const templateGlobalConfig = routeConfig?.templateConfig;
    const fontFamilyFromOtherLanguages = templateGlobalConfig?.variantConfig?.otherLanguagesConfig?.[locale]?.fontFamily;
    const fontFamilyFromMainLanguage = templateGlobalConfig?.theme?.fontFamily?.replace(" ", "");
    if (templateGlobalConfig) {
        return fontFamilyFromOtherLanguages || fontFamilyFromMainLanguage || (locale === "ar" ? "Almarai" : "Poppins");
    } else {
        return fontFamily || (locale === "ar" ? "Almarai" : "Poppins");
    }
};


/***/ }),

/***/ 19255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__NnJo8","headerContainer":"style_headerContainer__bfY8J","logo":"style_logo__oPgVZ","banner":"style_banner__nKv8j","close-button":"style_close-button__1RZQB","active":"style_active__DfBCW","banner-inner":"style_banner-inner__pvqcg","preHeader":"style_preHeader__0jNK7"};

/***/ }),

/***/ 81276:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainColor":"#126aa2"};

/***/ })

}]);